import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetAllYesNoListBySubTaskGuid = createAsyncThunk(
  "YesNo/GetAllYesNoListBySubTaskGuid",
  async (Id, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/YseNo/GetAllYesNoListBySubTaskGuid",
        {
          subTaskId: Id.subTaskId,
          mainTaskId: Id.mainTaskId,
        }
      );

      const data = response.data.result;
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const UpdateYesNoList = createAsyncThunk(
  "YesNo/UpdateYesNoList",
  async (param, { rejectWithValue }) => {
    try {
      //console.log(yesNoEvaluationUpdateList,"yesNoEvaluationUpdateList");

      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/YseNo/UpdateYesNoList", param);

      // Extract data from the response object
      const data = response.data; // Assuming response has a "data" field
      //console.log(data, "dataaaaaaaaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const ValidationYesNoList = createAsyncThunk(
  "YesNo/ValidationYesNoList",
  async (param, { rejectWithValue }) => {
    try {
      //console.log(yesNoEvaluationUpdateList,"yesNoEvaluationUpdateList");

      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/YseNo/ValidationYesNo", param);

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.message;
        });
        
        return arrayValidate; // Return the extracted data
      }

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
const YesNoManager = createSlice({
  name: "YesNoManager",
  initialState: {
    //------------------getBySubTask-------------------
    YesNoBySubTask: [],
    loadingYesNoBySubTask: false,
    errorYesNoBySubTask: null,
    //------------------update-------------------
    YesNoManagerUpdate: [],
    loadingYesNoManagerUpdate: false,
    errorYesNoManagerUpdate: null,
    //------------------Validation------------------
    YesNoManagerValidation: [],
    loadingYesNoManagerValidation: false,
    errorYesNoManagerValidation: null,
  },
  reducers: {
    SetYesNoManager: (state, action) => {
      state.YesNoManager = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAllYesNoListBySubTaskGuid.pending, (state, action) => {
        state.loadingYesNoBySubTask = true;
        state.YesNoBySubTask = action.payload;
        state.errorYesNoBySubTask = null;
      })
      .addCase(GetAllYesNoListBySubTaskGuid.fulfilled, (state, action) => {
        state.loadingYesNoBySubTask = false;
        state.YesNoBySubTask = action.payload;
      })
      .addCase(GetAllYesNoListBySubTaskGuid.rejected, (state, action) => {
        state.loadingYesNoBySubTask = false;
        state.errorYesNoBySubTask = action.payload;
      })

      .addCase(UpdateYesNoList.pending, (state, action) => {
        state.loadingYesNoManagerUpdate = true;
        state.YesNoManagerUpdate = action.payload;
        state.errorYesNoManagerUpdate = null;
      })
      .addCase(UpdateYesNoList.fulfilled, (state, action) => {
        state.loadingYesNoManagerUpdate = false;
        state.YesNoManagerUpdate = action.payload;
      })
      .addCase(UpdateYesNoList.rejected, (state, action) => {
        state.loadingYesNoManagerUpdate = false;
        state.errorYesNoManagerUpdate = action.payload;
      })
      //--------------------Validation------------------------
      .addCase(ValidationYesNoList.pending, (state, action) => {
        state.loadingYesNoManagerValidation = true;
        state.YesNoManagerValidation = action.payload;
        state.errorYesNoManagerValidation = null;
      })
      .addCase(ValidationYesNoList.fulfilled, (state, action) => {
        state.loadingYesNoManagerValidation = false;
        state.YesNoManagerValidation = action.payload;
      })
      .addCase(ValidationYesNoList.rejected, (state, action) => {
        state.loadingYesNoManagerValidation = false;
        state.errorYesNoManagerValidation = action.payload;
      });
  },
});

export const { SetYesNoManager } = YesNoManager.actions;

export default YesNoManager.reducer;
